import * as React from 'react';
import { useRouter } from 'next/router';
import { CancelSubscriptionRouter } from '../../modules/CancelSubscription/CancelSubscriptionRouter.js';

const CancelSubscriptionPage = ()=>{
    const router = useRouter();
    const subscriptionId = router.query.subscriptionId;
    const nextPossibleTerminationDateString = router.query.nextPossibleTerminationDate;
    const subscriptionInterval = router.query.subscriptionInterval;
    const nextPossibleTerminationDate = nextPossibleTerminationDateString ? new Date(nextPossibleTerminationDateString) : undefined;
    return /*#__PURE__*/ React.createElement(CancelSubscriptionRouter, {
        subscriptionId: subscriptionId,
        nextPossibleTerminationDate: nextPossibleTerminationDate,
        subscriptionInterval: subscriptionInterval
    });
};

export { CancelSubscriptionPage };
//# sourceMappingURL=CancelSubscriptionPage.js.map
